(function () {
  var textWithLogoDecoreAnimated = () => {

    gsap.to(".text-with-logo .mim-logo", {
      scrollTrigger: {
        trigger: ".text-with-logo",
        start: "top bottom",
        end: "bottom -150%",
        scrub: 0.1,
      },
      y: 200,
    });

  };

  document.addEventListener('shopify:section:load', function () {
    textWithLogoDecoreAnimated();
  });

  setTimeout(() => {
    textWithLogoDecoreAnimated();
  }, 900);
})();
